import angular from 'angular'
import routers from './routers.js'
import declarationProduceCtrl from './declarationProduceCtrl'

export default angular
  .module('declaration.corporateIncomeTax.declarationProduce', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('declarationProduceCtrl', declarationProduceCtrl).name


// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/declarationProduce/index.js